var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminLayout',[_c('UnpaidOrdersTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }